import { IAxiosLogger } from "@/gateways/graphql/connections/AxiosGraphQLConnection";
import { AxiosResponse } from "axios";
import { ILogger } from "./ILogger";

export class AxiosLogger implements IAxiosLogger {
  private logger: ILogger;

  constructor(logger: ILogger) {
    this.logger = logger;
  }

  public logRequest(query: string): void {
    this.logger.log("Requested:", query);
  }
  public logResponse(response: AxiosResponse<any>): void {
    this.logger.log("Responded:", response);
  }
  public logError(reason: any): void {
    this.logger.error(reason);
  }
}
